import React, { useState,useEffect } from "react";
import { toast } from "react-toastify";

const SourceTab = ({updateReviewTabData,reviewTabData}) => {
    const [businessName, setBusinessName] = useState(reviewTabData.business_name || "");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Sync with latest business_name from props
    useEffect(() => {
        setBusinessName(reviewTabData.business_name || "");
    }, [reviewTabData.business_name]);

    // State to manage the submission status
    const submitReviewForm = async (e) => {
        e.preventDefault();

        if (!businessName.trim()) {
            toast.error("Please enter an Booking.com Url.");
            return;
        }
        updateReviewTabData("business_name", businessName); 
        setIsSubmitting(true);
        // Simulate API delay
        setTimeout(() => {
            setIsSubmitting(false);
        }, 1500); 
        
    };

    return (
        <div className="side-baar-inner-source">
            <span>Source</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        placeholder="Enter Booking.com url..."
                        value={businessName}
                        onChange={(e) => setBusinessName(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={submitReviewForm}
                        disabled={isSubmitting}
                        className={isSubmitting ? "disabled" : ""}
                    >
                        {isSubmitting ? "Searching..." : "Search"}
                    </button>
                </div>
            </div>
            <p>
              Enter your booking.com property link (hotel, apartment, etc.) to display your reviews, for example: us/hi-new-york-hostel-nyc
            </p>
            <p>To get a link to your property, navigate to its page on booking.com, click the Share button, and then press Copy Link. Note: only .com domain links are supported.</p>
        </div>
    );
};

export default SourceTab;
